import { render, staticRenderFns } from "./footer-form-training.vue?vue&type=template&id=ec24b1d6&scoped=true"
import script from "./footer-form-training.vue?vue&type=script&lang=js"
export * from "./footer-form-training.vue?vue&type=script&lang=js"
import style0 from "./footer-form-training.vue?vue&type=style&index=0&id=ec24b1d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec24b1d6",
  null
  
)

export default component.exports